import { render } from "./Online.vue?vue&type=template&id=8049b5b4&scoped=true"
import script from "./Online.vue?vue&type=script&lang=js"
export * from "./Online.vue?vue&type=script&lang=js"

import "./Online.vue?vue&type=style&index=0&id=8049b5b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tmeadows\\WebstormProjects\\tuitioncalculator\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8049b5b4"]])

export default __exports__